import { Component, OnInit } from '@angular/core';
import { HeaderService } from './header.service';

@Component({
  selector: 'bidi-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  schoolName = 'School Name or Number';
  userName: string;
  changeBurger = false;

  constructor( private headerService: HeaderService) { }

  ngOnInit() {
    this.userName = this.headerService.getUserName();
  }

  expandMenu() {
    this.changeBurger = !this.changeBurger;
  }

}
